import React from "react";
import { Sankey } from "@ant-design/charts";
import { Divider } from "antd";

const HomepageRoutes = (props) => {


    const { routes = [] } = props;

    const colors = [
        "#6082a1",
        "#f1b8aa",
        "#d58dd5",
        "#b0cc98",
        "#78b283",
        "#c16c6c",
        "#f1f0aa"
    ];

    const rts = routes.map((item) => {
        return {
            source: "Home",
            target: item.route,
            value: parseInt(item.count),
        }
    })

    const data = {
        type: "sankey",
        sourceField: "source",
        targetField: "target",
        weightField: "value",
        color: colors,
        data: rts,
    };

    return (
        <div>
            <strong className="c" style={{ "fontSize": "13px" }}>Homepage Routes</strong>
            <div style={{ "fontSize": "14px" }}><small>The first page users visit after the homepage</small></div>
            <Divider dashed style={{ "margin": "10px 0px" }} />
            <Sankey {...data} height={400} />
        </div>
    )
};

export default HomepageRoutes;